var map = {
	"./payex-logo-h.svg": 4711,
	"./payex-logo-neg.png": 2742,
	"./payex-logo-neg.svg": 2608,
	"./payex-logo-v.svg": 9599,
	"./payex-logo.png": 959,
	"./payex-logo.svg": 3366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8358;